import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';

const FOOTER_LINK_ROWS = [
  [
    { title: 'KVKK Aydınlatma Metni', to: '/kvkk', rel: 'nofollow' },
    { title: 'Bilgi Güvenliği Politikamız', cmsKey: 'information_security_policy_title', to: '/bilgi-guvenligi-politikasi' },
    { title: 'Üyelik Sözleşmesi', to: '/uyelik-sozlesmesi', rel: 'nofollow' }
  ],
  [
    { title: 'Bilgi Toplumu Hizmetleri', to: '/bilgi-toplumu-hizmetleri', rel: 'nofollow' },
    { title: 'Hakkımızda', to: '/hakkimizda' },
    { title: 'Künye', to: '/kunye' }
  ]
];

const ForgotPasswordLayout = ({ isDesktop, children }) => (
  <div className={ classnames({ 'forgot-password-layout': true, 'forgot-password-layout--desktop': isDesktop }) }>
    <img className="forgot-password-bg forgot-password-bg--left" src="/public/images/forgot-password-pattern.webp" alt="" aria-hidden="true" />
    <img className="forgot-password-bg forgot-password-bg--right" src="/public/images/forgot-password-pattern.webp" alt="" aria-hidden="true" />
    <div className="forgot-password-layout__content">
      { children }
    </div>
    { isDesktop && <footer className="forgot-password-footer">
      <div className="forgot-password-footer__links">
        { FOOTER_LINK_ROWS.map((row, rowIndex) => (
          <div className="forgot-password-footer__row" key={ rowIndex }>
            { row.map(item => {
              const title = (item.cmsKey && EnvironmentManager.getMessageText({ key: item.cmsKey })) || item.title;

              return (
                <span className="forgot-password-footer__item" key={ item.to }>
                  <Link to={ item.to } title={ title } rel={ item.rel }>{ title }</Link>
                </span>
              );
            }) }
          </div>
        )) }
      </div>
      <p className="forgot-password-footer__copyright">
        Copyright © { new Date().getFullYear() }, Bilyoner İnteraktif Hizmetleri
      </p>
    </footer> }
  </div>
);

ForgotPasswordLayout.propTypes = {
  isDesktop: PropTypes.bool,
  children: PropTypes.node
};

export default ForgotPasswordLayout;
